import { Component, inject } from '@angular/core';
import { ListViewProviderDirective, NtapGlobalConstants } from '@ntap/core';
import { first, tap } from 'rxjs';

@Component({
  selector: `app-odabir-povezanog-posiljatelja`,
  templateUrl: './odabir-povezanog-posiljatelja.component.html'
})
export class OdabirPovezanogPosiljateljaComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(primatelji: any[]) {
    let id = 0;
    this.listviewProvider.view$
      .pipe(
        first(),
        tap((view) => {
          const parentJedinicaGradivaId = (
            this.listviewProvider.viewState as {
              'en~jedinica_gradiva~id': number;
            }
          )['en~jedinica_gradiva~id'];

          const posiljkaId = (
            this.listviewProvider.viewState as {
              'seup~posiljka~id': number;
            }
          )['seup~posiljka~id'];

          primatelji.forEach((posiljatelj) => {
            const naziv: string = this.getNazivFromPosiljatelj(posiljatelj);
            const newItem: any = {
              'sv~posiljka_posiljatelj~id': id,
              'sv~posiljka_posiljatelj~naziv_posiljatelja': naziv,
              'sv~posiljka_posiljatelj~drzava':
                posiljatelj['seup~subjekt~drzava'],
              'sv~posiljka_posiljatelj~mjesto':
                posiljatelj['seup~subjekt~mjesto'],
              'sv~posiljka_posiljatelj~ulica':
                posiljatelj['seup~subjekt~ulica'],
              'sv~posiljka_posiljatelj~email_address':
                posiljatelj['seup~subjekt~email_adress'],
              'sv~posiljka_posiljatelj~edelivery_address':
                posiljatelj['seup~subjekt~edelivery_adress'],
              'sv~posiljka_posiljatelj~original_subjekt_id':
                posiljatelj['seup~subjekt~id']
            };

            const updateItem: any = {
              'sv~posiljka_posiljatelj~id': id,
              'sv~posiljka_posiljatelj~entitet_id': parentJedinicaGradivaId,
              'sv~posiljka_posiljatelj~posiljka_id': posiljkaId,
              'sv~posiljka_posiljatelj~naziv_posiljatelja': naziv,
              'sv~posiljka_posiljatelj~drzava':
                posiljatelj['seup~subjekt~drzava'],
              'sv~posiljka_posiljatelj~ulica':
                posiljatelj['seup~subjekt~ulica'],
              'sv~posiljka_posiljatelj~mjesto':
                posiljatelj['seup~subjekt~mjesto'],
              'sv~posiljka_posiljatelj~email_address':
                posiljatelj['seup~subjekt~email_adress'],
              'sv~posiljka_posiljatelj~edelivery_address':
                posiljatelj['seup~subjekt~edelivery_adress'],
              'sv~posiljka_posiljatelj~original_subjekt_id':
                posiljatelj['seup~subjekt~id'],
              $itemType: 'sv~posiljka_posiljatelj'
            };

            id--;
            newItem[NtapGlobalConstants.ATTR_$itemType] = view.$mainType;
            this.listviewProvider.addItem(newItem);
            this.listviewProvider.updateItem(updateItem, 0);
          });
        })
      )
      .subscribe();

    this.showDialog = false;
  }

  getNazivFromPosiljatelj(posiljatelj: any): string {
    let naziv = '';
    if (posiljatelj['seup~subjekt~naziv']) {
      naziv = posiljatelj['seup~subjekt~naziv'];
    } else if (
      !!posiljatelj['seup~subjekt~ime'] &&
      !!posiljatelj['seup~subjekt~prezime']
    ) {
      naziv =
        posiljatelj['seup~subjekt~ime'] +
        ' ' +
        posiljatelj['seup~subjekt~prezime'];
    } else {
      naziv = '';
    }
    return naziv;
  }
}
